<template>
  <section
    class="ls-sources"
    aria-label="Sources"
  >
    <p class="ls-sources__line">{{ line }}</p>
    <ul
      v-if="links.length"
      class="ls-sources__links"
    >
      <li
        v-for="link in links"
        :key="link.url"
      >
        <a
          :href="link.url"
          target="_blank"
          rel="noopener nofollow"
        >{{ link.label || link.url }}</a>
      </li>
    </ul>
  </section>
</template>

<script>
import { sourcesLine } from './lineSheetModel'

const isWebLink = url => {
  try {
    return ['https:', 'http:'].includes(new URL(url).protocol)
  } catch (e) {
    return false
  }
}

export default {
  name: 'LsSources',
  props: {
    brandName: { type: String, required: true },
    website: { type: String, default: '' },
    updatedAt: { type: String, default: '' },
    sources: { type: Array, default: () => [] },
  },
  computed: {
    line() {
      return sourcesLine({ brandName: this.brandName, website: this.website, updatedAt: this.updatedAt })
    },
    links() {
      return this.sources.filter(s => s && isWebLink(s.url))
    },
  },
}
</script>

<style lang="scss" scoped>
@import './ls-base';

.ls-sources {
  max-width: $ls-max;
  margin: 0 auto;
  padding: 32px $ls-gutter 0;
  color: var(--ls-muted);
  font: 400 0.8125rem/1.6 var(--ls-body-font);

  &__line {
    margin: 0;
    max-width: 80ch;
  }

  &__links {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 18px;
    margin: 8px 0 0;
    padding: 0;
    list-style: none;

    a {
      color: var(--ls-ink);
      text-underline-offset: 3px;
      @include ls-focus;
    }
  }
}
</style>
